// pull in config vars
import * as config from "../config"
import getJamFilledCookie from "../getJamFilledCookie"
// import getUserIdFromJamFilledCookie from "../getUserIdFromJamFilledCookie"
import getUserIdFromLocalStorage from "../getUserIdFromLocalStorage"
import type { Thread } from "../../types"

export default async function addMessageToThread(
	threadId: string,
	message: string,
	JAM_ID: string,
): Promise<Thread | false> {
	try {
		const res = await fetch(
			`${config.API_HOSTNAME}/api/plugin/jam/${JAM_ID}/threads/${threadId}`,
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"jam-filled-cookie": getJamFilledCookie(),
					"jam-filled-userid": getUserIdFromLocalStorage(),
				},
				body: JSON.stringify({
					author: getUserIdFromLocalStorage(),
					message,
				}),
			},
		)

		const json = await res.json()

		// returns updated thread object
		return json
	} catch (e) {
		return false
	}
}
